import Api from '@/api/api'

/* All the Application related calls can be put here */
export default {
    getInitialData() {
        return Api.get('/api/InitialData/GetSuperAdminInitialData');
        // return Api.get('ETMSAgr/InitialData/GetInitialData?facilityID=' + facilityID)
    },
    async getRoute(host, coordinates) {
        let d = await fetch(host + "/v2/directions/driving-car", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ coordinates })
        })
        let data = await d.json();
        return data;
    },
    getSosCount() {
        return Api.get("/api/SOS/GetSosCount");
    },


}